import React from "react"
import { connect } from "react-redux"
import DailyAnalyticsHolder from "../components/DailyAnalyticsHolder"
import ShardedAnalyticsHolder from "../components/ShardedAnalyticsHolder"
import requireStore from "../decorators/requireStore"
import { authorize } from "../decorators/authorize"
import { analyticsPage } from "../config/routesInfo"
import {
  refreshDailyAnalytics,
  getItems,
  refreshDailyProductAnalytics,
  nullProductAnalytics,
} from "../ducks/analytics"
import {
  changeShardedAnalyticsRange,
  refreshAllShardedAnalytics,
  refreshShardedAnalytics,
  // shardedAnalyticsTypes,
  refreshShardedProductAnalytics,
  changeShardedProductAnalyticsRange,
  refreshAllShardedProductAnalytics,
  nullShardedProductAnalytics,
} from "../ducks/shardedAnalytics"
import { subDays } from "date-fns"
import {
  shardedAnalyticsTypes,
  refreshShardedAnalytic,
  createShardedAnalytic,
  setShardedAnalyticDateFunction,
  setShardedAnalyticTypeFunction,
  deleteShardedAnalyticFunction,
  refreshShardedProductAnalytic,
  refreshAllShardedProductAnalytic,
  refreshAllShardedAnalytic,
} from "../ducks/shardedAnalyticsNew"

@authorize(...analyticsPage.permissions)
@requireStore()
@connect(
  (state) => {
    return {
      currentStoreId: state.profile.currentStore.id,
      today: state.analytics.today,
      yesterday: state.analytics.yesterday,
      purchaseAnalytics: state.shardedAnalytics.purchase,
      profitAnalytics: state.shardedAnalytics.profit,
      saleAnalytics: state.shardedAnalytics.sale,
      startDate: state.shardedAnalytics.startDate,
      endDate: state.shardedAnalytics.endDate,
      items: state.analytics.items.items,
      startDates: state.shardedAnalyticsNew.startDates,
      endDates: state.shardedAnalyticsNew.endDates,
      types: state.shardedAnalyticsNew.types,
      isLoadings: state.shardedAnalyticsNew.isLoadings,
      analytics: state.shardedAnalyticsNew.analytics,
      last: state.shardedAnalyticsNew.last,
    }
  },
  (dispatch) => {
    return {
      refreshDaily: () => {
        dispatch(refreshDailyAnalytics())
      },
      changeRange: (...data) => {
        dispatch(changeShardedAnalyticsRange(...data))
      },
      refreshShardedProfit: () =>
        dispatch(refreshShardedAnalytics(shardedAnalyticsTypes.profit)),
      refreshShardedSale: () =>
        dispatch(refreshShardedAnalytics(shardedAnalyticsTypes.sale)),
      refreshShardedPurchase: () =>
        dispatch(refreshShardedAnalytics(shardedAnalyticsTypes.purchase)),
      refreshSharded: () => dispatch(refreshAllShardedAnalytics()),
      getItems: (value) => dispatch(getItems(value)),
      refreshDailyProductAnalytics: (id) =>
        dispatch(refreshDailyProductAnalytics(id)),
      createShardedAnalytic: (startDate, endDate, type) =>
        dispatch(createShardedAnalytic(startDate, endDate, type)),
      setShardedAnalyticTypeFunction: (id, type) =>
        dispatch(setShardedAnalyticTypeFunction(id, type)),
      setShardedAnalyticDateFunction: (id, startDate, endDate) =>
        dispatch(setShardedAnalyticDateFunction(id, startDate, endDate)),
      refreshShardedAnalytic: (id) => dispatch(refreshShardedAnalytic(id)),
      deleteShardedAnalyticFunction: (id) =>
        dispatch(deleteShardedAnalyticFunction(id)),
      refreshProductShardedAnalytic: (id, prodId) =>
        dispatch(refreshShardedProductAnalytic(id, prodId)),
      refreshAllShardedProductAnalytic: (prodId) =>
        dispatch(refreshAllShardedProductAnalytic(prodId)),

      // FOR ONE PRODUCT
      refreshShardedProductProfit: (id) =>
        dispatch(
          refreshShardedProductAnalytics(shardedAnalyticsTypes.profit, id),
        ),
      refreshShardedProductSale: (id) =>
        dispatch(
          refreshShardedProductAnalytics(shardedAnalyticsTypes.sale, id),
        ),
      refreshShardedProductPurchase: (id) =>
        dispatch(
          refreshShardedProductAnalytics(shardedAnalyticsTypes.purchase, id),
        ),
      changeProductRange: (...data) => {
        dispatch(changeShardedProductAnalyticsRange(...data))
      },
      refreshProductSharded: (id) => {
        dispatch(refreshAllShardedProductAnalytics(id))
      },
      nullShardedProductAnalytics: (...data) => {
        dispatch(nullShardedProductAnalytics(...data))
      },
      nullProductAnalytics: () => {
        dispatch(nullProductAnalytics())
      },
      refreshAllShardedAnalytic: () => dispatch(refreshAllShardedAnalytic()),
    }
  },
)
export default class AnalyticsPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      queryText: "",
      resultText: false,
      pick: false,
    }
    const today = new Date()
    props.changeRange(subDays(today, 7), today)
    props.refreshDaily()
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(newProps) {
    const { currentStoreId, refreshDaily, refreshSharded } = this.props
    if (newProps.currentStoreId !== currentStoreId) {
      refreshDaily()
      refreshSharded()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      changeRange,
      refreshDaily,
      refreshSharded,
      nullShardedProductAnalytics,
      nullProductAnalytics,
      refreshAllShardedAnalytic,
    } = this.props
    const today = new Date()
    if (prevState.pick === false && prevState.pick !== this.state.pick) {
      this.props.getItems(null)
      nullProductAnalytics()
      nullShardedProductAnalytics(subDays(today, 7), today)
    }
    if (prevState.pick === true && prevState.pick !== this.state.pick) {
      changeRange(subDays(today, 7), today)
      refreshDaily()
      refreshSharded()
      refreshAllShardedAnalytic()
      this.setState({
        resultText: false,
      })
    }
  }

  handlePick = (e) => {
    this.setState({
      pick: !this.state.pick,
    })
  }

  hanldeFocus = (e) => {
    this.setState({
      resultText: false,
    })
  }

  handleChange = (e) => {
    this.setState({ queryText: e.target.value })
    this.props.getItems(e.target.value)
  }

  handleSelect = (e, { value }) => {
    this.setState({ resultText: value })
  }

  handleClick = (e, { value }) => {
    const { resultText } = this.state
    if (resultText) {
      this.props.refreshDailyProductAnalytics(resultText)
      // this.props.refreshProductSharded(resultText)
      this.props.refreshAllShardedProductAnalytic(resultText)
    }
    // this.props.getItems(null)
  }

  render() {
    const {
      today,
      yesterday,
      refreshDaily,
      refreshDailyProductAnalytics,
      startDate,
      endDate,
      changeRange,
      changeProductRange,
      refreshShardedProfit,
      refreshShardedProductProfit,
      refreshShardedPurchase,
      refreshShardedProductPurchase,
      refreshShardedSale,
      refreshShardedProductSale,
      profitAnalytics,
      purchaseAnalytics,
      saleAnalytics,
      items,
      deleteShardedAnalytic,
      setShardedAnalyticData,
      setShardedAnalyticType,
      setShardedAnalyticLoading,
      setShardedAnalyticDate,
      addShardedAnalytic,
      createShardedAnalytic,
      setShardedAnalyticTypeFunction,
      setShardedAnalyticDateFunction,
      refreshShardedAnalytic,
      deleteShardedAnalyticFunction,
      startDates,
      endDates,
      types,
      isLoadings,
      analytics,
      last,
    } = this.props
    return (
      <div className="analytics-page">
        <DailyAnalyticsHolder
          today={today}
          yesterday={yesterday}
          onRefreshDaily={refreshDaily}
          onRefreshProductDaily={refreshDailyProductAnalytics}
          handleChange={this.handleChange}
          hanldeFocus={this.hanldeFocus}
          handleSelect={this.handleSelect}
          handleClick={this.handleClick}
          handlePick={this.handlePick}
          pick={this.state.pick}
          resultText={this.state.resultText}
          items={items.map((item) => ({
            key: item.stockId,
            value: item.stockId,
            text: item.name,
          }))}
        />
        <ShardedAnalyticsHolder
          onRangeChange={changeRange}
          onProductRangeChange={changeProductRange}
          endDate={endDate}
          startDate={startDate}
          resultText={this.state.resultText}
          onRefreshShardedProfit={refreshShardedProfit}
          onRefreshShardedProductProfit={refreshShardedProductProfit}
          onRefreshShardedPurchase={refreshShardedPurchase}
          onRefreshShardedProductPurchase={refreshShardedProductPurchase}
          onRefreshShardedSale={refreshShardedSale}
          onRefreshShardedProductSale={refreshShardedProductSale}
          profitAnalytics={profitAnalytics}
          purchaseAnalytics={purchaseAnalytics}
          saleAnalytics={saleAnalytics}
          pick={this.state.pick}
          createShardedAnalytic={createShardedAnalytic}
          shardedAnalyticsTypes={shardedAnalyticsTypes}
          deleteShardedAnalytic={deleteShardedAnalytic}
          setShardedAnalyticData={setShardedAnalyticData}
          setShardedAnalyticType={setShardedAnalyticType}
          setShardedAnalyticLoading={setShardedAnalyticLoading}
          setShardedAnalyticDate={setShardedAnalyticDate}
          setShardedAnalyticTypeFunction={setShardedAnalyticTypeFunction}
          setShardedAnalyticDateFunction={setShardedAnalyticDateFunction}
          refreshShardedAnalytic={refreshShardedAnalytic}
          addShardedAnalytic={addShardedAnalytic}
          deleteShardedAnalyticFunction={deleteShardedAnalyticFunction}
          startDates={startDates}
          endDates={endDates}
          types={types}
          isLoadings={isLoadings}
          analytics={analytics}
          last={last}
        />
        <div style={{ height: 20 }}>{""}</div>
      </div>
    )
  }
}
